module.exports = __webpack_public_path__ + "img/翼康养老.5a1450c9.png";